import {
  SETTING_INVENTORY_SET_ROLES,
  SETTING_INVENTORY_SET_PERMISSIONS,
} from '../../actions/setting/inventory/constant';
import {
  InventorySettingSetRolesAction,
  InventorySettingSetPermissionsAction,
} from '../../actions/setting/inventory/types';
import createReducer from '../../utils/createReducer';
import { SimplifiedCreateReducerHandlers } from '../../types/common';
import { Permission, Role } from '../../types/roles/Role';

export const roles = createReducer<Role[]>([], {
  [SETTING_INVENTORY_SET_ROLES]: (
    draft,
    { payload }: InventorySettingSetRolesAction
  ) => payload!.roles,
} as SimplifiedCreateReducerHandlers<Role[], InventorySettingSetRolesAction>);

export const permissions = createReducer<Permission[]>([], {
  [SETTING_INVENTORY_SET_PERMISSIONS]: (
    draft,
    { payload }: InventorySettingSetPermissionsAction
  ) => payload!.permissions,
} as SimplifiedCreateReducerHandlers<Permission[], InventorySettingSetPermissionsAction>);
